module.exports = __webpack_public_path__ + "static/media/hand-lizard.ad4c9261.svg";